import { render, staticRenderFns } from "./DocumentsPicker.vue?vue&type=template&id=4b03dd4e&scoped=true&"
import script from "./DocumentsPicker.vue?vue&type=script&lang=js&"
export * from "./DocumentsPicker.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsPicker.vue?vue&type=style&index=0&id=4b03dd4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b03dd4e",
  null
  
)

export default component.exports